import React from 'react';
import { classNames } from '../helpers/functions';

export const Button = ({
	children,
	onClick,
	type = 'primary',
	focus = false,
	className,
	disabled,
	ref,
	Icon,
}) => {
	return (
		<button
			ref={ref}
			type="button"
			onClick={() => typeof onClick === 'function' && !disabled && onClick()}
			className={classNames(
				'inline-flex items-center rounded-md border px-4 py-2 text-xs font-medium',
				!disabled && type === 'primary'
					? 'border-transparent bg-indigo-600 text-white shadow-sm hover:bg-indigo-700'
					: '',
				!disabled && type === 'secondary'
					? 'border-gray-300 bg-white text-gray-700 shadow-sm hover:bg-gray-50'
					: '',
				!disabled && type === 'danger'
					? 'border-red-200 bg-white text-red-700 shadow-sm hover:bg-red-50'
					: '',
				!disabled && type === 'ghost'
					? 'border-transparent bg-white text-gray-700 focus:outline-0 focus:ring-0'
					: '',
				!disabled && focus
					? 'focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'
					: '',
				className,
				disabled
					? 'bg-gray-200 text-gray-400 hover:bg-gray-200 cursor-default focus:ring-0'
					: ''
			)}
		>
			{Icon && <Icon className="w-4 h-4 mr-1.5" />}
			{children}
		</button>
	);
};

export const PrimaryButton = ({ children, onClick }) => (
	<button
		type="button"
		className=""
		onClick={() => typeof onClick === 'function' && onClick()}
	>
		{children}
	</button>
);

export const SecondaryButton = ({ children, onClick }) => (
	<button
		type="button"
		className="border-gray-300 bg-white text-gray-700 shadow-sm hover:bg-gray-50"
		onClick={() => typeof onClick === 'function' && onClick()}
	>
		{children}
	</button>
);

export const GhostButton = ({ children, onClick }) => (
	<button
		type="button"
		className="ml-0 sm:ml-3 inline-flex items-center rounded-md bg-white px-4 py-4 sm:py-2 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
		onClick={() => typeof onClick === 'function' && onClick()}
	>
		{children}
	</button>
);
